import type { UUID } from '@/utils/uuid';

export const enrollmentQueryKeys = {
  credentials: (tenantId?: UUID, kind?: string) =>
    ['enrollment-credentials', tenantId, kind ?? null] as const,
  credentialsByTenant: (tenantId?: UUID) =>
    ['enrollment-credentials', tenantId] as const,
  uses: (tenantId?: UUID, credentialId?: UUID) =>
    ['enrollment-credential-uses', tenantId, credentialId] as const,
};

export const enrollmentMutationKeys = {
  issueJoinCode: (tenantId?: UUID) => ['issueJoinCode', tenantId] as const,
  createSecret: (tenantId?: UUID) =>
    ['createEnrollmentSecret', tenantId] as const,
  revokeCredential: (tenantId?: UUID) =>
    ['revokeEnrollmentCredential', tenantId] as const,
  rotateSecret: (tenantId?: UUID) =>
    ['rotateEnrollmentSecret', tenantId] as const,
};
